import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AslibModalComponent, AslibModalDismissReasons, AslibModalService } from '@aslib/modal';
import { Subscription } from 'rxjs/Subscription';
import { ModalManagerHelper } from '../../shared/helpers/modal-manager-helper';
import { Ano, Banco, ControleArquivoReceitaFiltro, ControleArquivoReceitaModelView, TipoReceita } from './shared/model/geracao-arquivo-ipm.model';
import { AslibLoadingService } from '@aslib/loading';
import { Messages } from '../../shared/helpers/mensages';

import {GeracaoArquivoIpmService} from './shared/service/geracao_arquivo-ipm.service';
import {saveAs as importedSaveAs } from "file-saver";
import { StatusArquivo } from '../../shared/enum/StatusArquivo';


@Component({
  selector:'sarf-geracao-arquivo-ipm',
  templateUrl:'./geracao-arquivo-ipm.component.html'
})

export class GerarArquivoIpmComponent implements OnInit {
  subscription: Subscription;
  observerOnIniftFormulario: Subscription;
  aslibModal: AslibModalComponent;


  podeAcao:boolean;
  exibirGrid:boolean;

  // Botão 
  disabiliaGeracao: boolean;

  disabilitarAceite: boolean;
  desabilitarRejeite: boolean;
  desabilitarCancele: boolean;

  titleValueBotaoAceite: string;	 
  titleValueBotaoRejeite: string;
	titleValueBotaoCancele: string;

  listaAno: Ano[];
  listaBanco: Banco[];
  listaTipoReceita: TipoReceita[];

  
  _anoSelected: Ano;
  _bancoSelected: Banco;
  _tipoReceitaSelected: TipoReceita;
  _sequencialSelected:number;
  
  _nomeArquivo: string;
  _minSequencial: number;

  _titleModal:string;
  _textModal:string;


  filtro: ControleArquivoReceitaFiltro;

  controleArquivoReceitaModelView: ControleArquivoReceitaModelView;

  @ViewChild(AslibModalComponent) modalMensagem: AslibModalComponent;

  constructor(
    private readonly controleArquivoReceitaService : GeracaoArquivoIpmService,
    private readonly modalManagerHelper: ModalManagerHelper,
    private readonly _aslibLoadingService: AslibLoadingService,
    private readonly _aslibModalService: AslibModalService,
    private readonly _messages : Messages

  ) {
    modalManagerHelper.parent = this;
    this.controleArquivoReceitaModelView = new ControleArquivoReceitaModelView();
    this.filtro =  new ControleArquivoReceitaFiltro();
    this.exibirGrid=true;
  
    this.podeAcao=false;
  }

  formGeracaoIpm = new FormGroup({
    Ano: new FormControl(),
    Banco: new FormControl(),
    TipoReceita: new FormControl(),
    Sequencial: new FormControl(),
  })

  ngOnInit() {

    this.exibirGrid =false;
    this.dadosOnInitFormulario(this.modalMensagem);
    this.disabiliaGeracao=true;
    this.habilitaDesabilitaBotaoAcao(null);
    this.podeAcao=false;

  }

  dadosOnInitFormulario(modal: AslibModalComponent){
    this.observerOnIniftFormulario = this.controleArquivoReceitaService.dadosOnInitFormulario().subscribe(
      retornoRequest => {

        this.limpaFiltro();

        this.listaAno = retornoRequest.ListaAno;

        this.setarMaiorAnoDaLista();

        this.listaBanco = retornoRequest.ListaBanco;

        this.setarBanco();

        this.listaTipoReceita = retornoRequest.ListaTipoReceita;   

        this.exibirGrid=false;

        this.podeAcao=false;

        this.consultarControleArquivoReceitaTodos(this.modalMensagem);
     
        if(retornoRequest.objetoMensagem &&  retornoRequest.objetoMensagem.Mensagem !== null &&  retornoRequest.objetoMensagem.Mensagem !== ''){
          this.modalManagerHelper.modalMensagem(modal, retornoRequest.objetoMensagem);
        }

      },
      () => this.observerOnIniftFormulario.unsubscribe()
    );
  }

  consultarControleArquivoReceitaTodos(modal: AslibModalComponent) {

    this.limpaFiltro();
    this.filtroConsulta();

    this.observerOnIniftFormulario = this.controleArquivoReceitaService    
    .consultarControleArquivoReceitaTodos().subscribe(
 
      retornoRequest => {
      
        this.controleArquivoReceitaModelView.ListaControleArquivoReceita = retornoRequest.ListaControleArquivoReceita;
           
        let c = this.controleArquivoReceitaModelView.ListaControleArquivoReceita.length;
        
        this.exibirGrid = c>0?true:false;

        if(retornoRequest.objetoMensagem &&  retornoRequest.objetoMensagem.Mensagem !== null &&  retornoRequest.objetoMensagem.Mensagem !== ''){
          this.modalManagerHelper.modalMensagem(modal, retornoRequest.objetoMensagem);
         }
       },
       () => this.observerOnIniftFormulario.unsubscribe()
     );
  }

  consultarControleArquivoReceita(modal: AslibModalComponent) {

    this.limpaFiltro();
    this.filtroConsulta();
    
    this.observerOnIniftFormulario = this.controleArquivoReceitaService
    .consultarControleArquivoReceita(this.filtro).subscribe(

      retornoRequest => {
      
        this.controleArquivoReceitaModelView.ListaControleArquivoReceita = retornoRequest.ListaControleArquivoReceita;
           
        let c = this.controleArquivoReceitaModelView.ListaControleArquivoReceita.length;
        
        this.exibirGrid = c>0?true:false;

        if(retornoRequest.objetoMensagem &&  retornoRequest.objetoMensagem.Mensagem !== null &&  retornoRequest.objetoMensagem.Mensagem !== ''){
          this.modalManagerHelper.modalMensagem(modal, retornoRequest.objetoMensagem);
         }
       },
       () => this.observerOnIniftFormulario.unsubscribe()
     );
  }
   
  public filtroConsulta(){

    this.filtro.IdAno = this._anoSelected? this._anoSelected.IdAno : null;
    this.filtro.IdBanco = this._bancoSelected ? this._bancoSelected.IdBanco : null;
    this.filtro.IdTipoReceita =  this._tipoReceitaSelected ? this._tipoReceitaSelected.IdTipoReceita : null;
    this.filtro.Sequencial = this._sequencialSelected?this._sequencialSelected.toString():"1";

  }

  public limpaFiltro(){
    this.filtro.IdAno = null;
    this.filtro.IdBanco =  null;
    this.filtro.IdTipoReceita =  null;
    this.filtro.Sequencial ="";
  }
  
  gerarArquivoIpmtxt() {
   
    this.limpaFiltro();
    this.filtroConsulta();

    if (this._sequencialSelected < this._minSequencial) {

      new AslibModalComponent(this._aslibModalService).open({ title: 'Mensagem', text: 'Só é possível gerar arquivo com sequencial maior que o último gerado.', type: 'info' });
      return;

    }

 this.subscription =  this.controleArquivoReceitaService.validarGeracaoArquivoIpm(this.filtro)
      .subscribe(
        data => {
        if(data.Key==false){
            new AslibModalComponent(this._aslibModalService).open({ title: 'Mensagem', text: data.Value, type: 'info' });
            return;
        }else{
            this.geraArquivoIpmValidado();
        }
        })

  }

  geraArquivoIpmValidado(){
    
this._aslibLoadingService.start();
    this.subscription =  this.controleArquivoReceitaService.gerarArquivoIpm(this.filtro)
      .subscribe(
        data => {
        importedSaveAs(data,  this._nomeArquivo );

        this.validaTipo();

        },
        (error: any) => {
          
          this._aslibLoadingService.complete();
          
          new AslibModalComponent(this._aslibModalService).open({
            
            title: 'Mensagen',
            text: this._messages.MN0090,
            type: 'info'
          }
          
          );
        },
        () => {
          this.unSubscribe(); 
        }
      );

  }
  
  updateStatusArquivoIpm(item:any){
    
    this._aslibLoadingService.start();
      this.subscription =  this.controleArquivoReceitaService.alterarStatusArquivoIpm(item)
        .subscribe(
          data => {

            this.validaTipo();
            
            this.exibirSucesso();

          },
          (error: any) => {
            
            this.exibirNaoAlterado();
            
          },
          () => {
            this.unSubscribe(); 
          }
        );
  }

  permiteAcao(item:any, status: number){

    item.IdSituacaoModificada = status;
    
    this._aslibLoadingService.start();
      this.subscription =  this.controleArquivoReceitaService.permiteAlterarStatusArquivoIpm(item)
        .subscribe(
          data => {
            
              this.podeAcao = data;

              if(!this.podeAcao){

                if(       
                  item.IdSituacaoProcessamento==StatusArquivo.CANCELADO){
                  this.exibirCanceladoSemPermissaoAlterarStatus();
                }else{
                  this.exibirBloqueado();
                }
          
              }else{
                  this.executaUpdate(item, status);
              }
           
            },
          () =>  {},
          () => {
            this.unSubscribe(); 
          }
        );
  }

  clearForms(){
    this.limpaFiltro();
    this.consultarControleArquivoReceitaTodos(this.modalMensagem);
  }


  validarGeracao(){
    this.limpaFiltro();
    this.filtroConsulta();
    if(
      this.filtro.IdTipoReceita !=null 
      && this.filtro.IdAno !=null 
      && this.filtro.IdBanco ){

        this.controleArquivoReceitaService.validarArquivoIpm(this.filtro).subscribe((data) => {
            this._nomeArquivo = data.NomeArquivo;
        });

        this.controleArquivoReceitaService.gerarSequencialIpm(this.filtro).subscribe((data) => {
          this._minSequencial = Number(data);
          this._sequencialSelected = this._minSequencial;
        });

        this.disabiliaGeracao=false;

    }else{
      this.disabiliaGeracao=true;
    }

  }

  validaAno(){
    this.limpaFiltro();
    this.filtroConsulta();
    if(this.filtro.IdTipoReceita !=null){
      this.consultarControleArquivoReceita(this.modalMensagem);
    }else{
      this.consultarControleArquivoReceitaTodos(this.modalMensagem);
    }
    if(this.filtro.IdTipoReceita !=null || this.filtro.IdAno !=null){this.validarGeracao();}
  }

  validaTipo(){


    this.limpaFiltro();
    this.filtroConsulta();
    

    if(this.filtro.IdTipoReceita ==null ){
      this._minSequencial=null;
      this._sequencialSelected=null;

    }

    if(this.filtro.IdTipoReceita !=null || this.filtro.IdAno !=null){
      this.consultarControleArquivoReceita(this.modalMensagem);
      this.validarGeracao();
    }else{
      this.consultarControleArquivoReceitaTodos(this.modalMensagem);
    }

  }

  public statusArquivo(item:any, status:number)
  {
   
    if ( item!==null || 'undefined'){
      
      if (this.getDataBloqueiada(item)){
        return
      }

    }
    this.setModalStatus(status)
   
    this.permiteAcao(item, status);
       
  }
  
  validarSequencial() {

    this.filtroConsulta();

    if (this._sequencialSelected < this._minSequencial) {
       this._sequencialSelected = this._minSequencial;
    }

  }

  public validaStatus(status:number,item:any){

    if(status!==null && status!=undefined){

        this.habilitaDesabilitaBotaoAcao(item);
        return status
     }
     
  }


  public getDataBloqueiada(item:any){

    const QuantidadeAnoBloqueio: number = 2;
    const anoCorrente: number = new Date().getFullYear();
    let anoVerificado: number = new Date(item.DataGeracao).getFullYear();
    let totalAnosCalculado: number =0;

    if(
      item.DataGeracao!== '0001-01-01T00:00:00' && 
      item.DataGeracao!==null && 
      item.DataGeracao!='undefined'  ){
     
        totalAnosCalculado = anoCorrente-anoVerificado;
    }

    return totalAnosCalculado>QuantidadeAnoBloqueio;

  }
  
  public setarMaiorAnoDaLista(){
    if(this.listaAno != null ){
      this._anoSelected = this.listaAno[0];
    }
  }

  public setarBanco(){
    if(this.listaBanco != null ){
      this._bancoSelected = this.listaBanco[0];
    }
  }

  public validaItem(item:any){
     if(item!== '0001-01-01T00:00:00' && item!==null && item!='undefined'){
         return item;
      }
  }

  public setModalStatus(status:number){

    switch (status) {
      case StatusArquivo.ACEITO:
        this._titleModal = 'Aceita Arquivo';
        this._textModal='Confirma alteração de status do arquivo para Aceito pelo Banco?';
          break;
      case StatusArquivo.REJEITADO:
        this._titleModal = 'Rejeita Arquivo';
        this._textModal='Confirma alteração de status do arquivo para Rejeitado pelo Banco?';
          break;
      case StatusArquivo.CANCELADO:
            this._titleModal = 'Cancela Arquivo';
            this._textModal='Confirma alteração de status do arquivo para Cancelado?';
            break;
      default:
          // default statement
          break;
    }

  }

  public setTitleBotaoAcao( botao:number, habilitado:boolean){

    let titleBloqueadoBotao: string = "Mudança de status bloqueada por ultrapassar o período permitido";
    let titleDesbloqueadoBotaoAceite: string = "Registrar o aceite do arquivo";	 
    let titleDesbloqueadoBotaoRejeite: string = "Registrar a rejeição do arquivo";
    let titleDesbloqueadoBotaoCancele: string = "Registrar o cancelamento do arquivo";

    switch (botao) {
      case StatusArquivo.ACEITO:
          this.titleValueBotaoAceite = habilitado?titleDesbloqueadoBotaoAceite:titleBloqueadoBotao;
          break;
      case StatusArquivo.REJEITADO:   	 
        this.titleValueBotaoRejeite =  habilitado?titleDesbloqueadoBotaoRejeite:titleBloqueadoBotao;
        break;
      case StatusArquivo.CANCELADO:   	 
        this.titleValueBotaoCancele =  habilitado?titleDesbloqueadoBotaoCancele:titleBloqueadoBotao;
        break;
      default:
          // default statement
        break;
    }

  }

  public setDisableBotaoAcao( botao:number, habilitado:boolean){


    switch (botao) {
      case StatusArquivo.ACEITO:
          this.disabilitarAceite = habilitado;
          break;
      case StatusArquivo.REJEITADO:   	 
        this.desabilitarRejeite =  habilitado;
        break;
      case StatusArquivo.CANCELADO:   	 
        this.desabilitarCancele =  habilitado;
        break;
      default:
          // default statement
        break;
    }

  }

  public habilitaDesabilitaBotaoAcao(item:any){

    if(item!==null && item!=undefined){
       

      if (this.getDataBloqueiada(item)){
        

        this.setDisableBotaoAcao(StatusArquivo.ACEITO, true);
        this.setDisableBotaoAcao(StatusArquivo.REJEITADO, true);
        this.setDisableBotaoAcao(StatusArquivo.CANCELADO, true);
        this.setTitleBotaoAcao(StatusArquivo.ACEITO, false);
        this.setTitleBotaoAcao(StatusArquivo.REJEITADO, false);
        this.setTitleBotaoAcao(StatusArquivo.CANCELADO, false);

        return;
      }


      switch (item.IdSituacaoProcessamento) {

        case StatusArquivo.GERADO:
          
          this.setDisableBotaoAcao(StatusArquivo.ACEITO, true);
          this.setDisableBotaoAcao(StatusArquivo.REJEITADO, true);
          this.setDisableBotaoAcao(StatusArquivo.CANCELADO, false);
  
          this.setTitleBotaoAcao(StatusArquivo.ACEITO, true);
          this.setTitleBotaoAcao(StatusArquivo.REJEITADO, true);
          this.setTitleBotaoAcao(StatusArquivo.CANCELADO, true);

           break;
        case StatusArquivo.TRANSMITIDO:

          this.setDisableBotaoAcao(StatusArquivo.ACEITO, false);
          this.setDisableBotaoAcao(StatusArquivo.REJEITADO, false);
          this.setDisableBotaoAcao(StatusArquivo.CANCELADO, false);
  
          this.setTitleBotaoAcao(StatusArquivo.ACEITO, true);
          this.setTitleBotaoAcao(StatusArquivo.REJEITADO, true);
          this.setTitleBotaoAcao(StatusArquivo.CANCELADO, true);

           break;
        case StatusArquivo.ACEITO:
          this.setDisableBotaoAcao(StatusArquivo.ACEITO, true);
          this.setDisableBotaoAcao(StatusArquivo.REJEITADO, false);
          this.setDisableBotaoAcao(StatusArquivo.CANCELADO, false);
  
          this.setTitleBotaoAcao(StatusArquivo.ACEITO, true);
          this.setTitleBotaoAcao(StatusArquivo.REJEITADO, true);
          this.setTitleBotaoAcao(StatusArquivo.CANCELADO, true);

           break;
        case StatusArquivo.REJEITADO:

        this.setDisableBotaoAcao(StatusArquivo.ACEITO, false);
        this.setDisableBotaoAcao(StatusArquivo.REJEITADO, true);
        this.setDisableBotaoAcao(StatusArquivo.CANCELADO, false);

        this.setTitleBotaoAcao(StatusArquivo.ACEITO, true);
        this.setTitleBotaoAcao(StatusArquivo.REJEITADO, true);
        this.setTitleBotaoAcao(StatusArquivo.CANCELADO, true);

           break;
        case StatusArquivo.CANCELADO:
   
           if(item.DataTransmissao!== '0001-01-01T00:00:00' && item.DataTransmissao!==null && item.DataTransmissao!='undefined'){
            
            this.setDisableBotaoAcao(StatusArquivo.ACEITO, false);
            this.setDisableBotaoAcao(StatusArquivo.REJEITADO, false);
            this.setDisableBotaoAcao(StatusArquivo.CANCELADO, true);
    
            this.setTitleBotaoAcao(StatusArquivo.ACEITO, true);
            this.setTitleBotaoAcao(StatusArquivo.REJEITADO, true);
            this.setTitleBotaoAcao(StatusArquivo.CANCELADO, true);
            
           }else{

            this.setDisableBotaoAcao(StatusArquivo.ACEITO, true);
            this.setDisableBotaoAcao(StatusArquivo.REJEITADO, true);
            this.setDisableBotaoAcao(StatusArquivo.CANCELADO, true);
    
            this.setTitleBotaoAcao(StatusArquivo.ACEITO, true);
            this.setTitleBotaoAcao(StatusArquivo.REJEITADO, true);
            this.setTitleBotaoAcao(StatusArquivo.CANCELADO, true);

           }
     
           break;
        default:
             // default statement
           break;
      }

    }else{
      this.setDisableBotaoAcao(StatusArquivo.ACEITO, true);
      this.setDisableBotaoAcao(StatusArquivo.REJEITADO, true);
      this.setDisableBotaoAcao(StatusArquivo.CANCELADO, true);
      this.setTitleBotaoAcao(StatusArquivo.ACEITO,true);
      this.setTitleBotaoAcao(StatusArquivo.REJEITADO,true);
      this.setTitleBotaoAcao(StatusArquivo.CANCELADO,true);
    }

  }
   
  executaUpdate(item:any, status:number)
  {
  
    var modal =  new AslibModalComponent(this._aslibModalService);   
    var mensagem = 
    {
      title: this._titleModal,
      backdrop: 'static',
      Mensagem: this._textModal,
      okText: 'Sim',
      cancelarText: 'Não',
      cancelarVisible: true
    }

    this.modalManagerHelper
    .modalpergunta(modal,null, mensagem);
    modal
    .open().result.then(
    result => {
    if (AslibModalDismissReasons[result] === 'OK') 
    {
        
          item.IdSituacaoProcessamento=status;
          this.updateStatusArquivoIpm(item);  
        
        }
        },
        reason => { }
    );
  }

  exibirSucesso(){
    var texto = "O arquivo alterado com sucesso.";
            
    this._aslibLoadingService.complete();
    
    new AslibModalComponent(this._aslibModalService).open(
      {
        title: 'Mensagem',
        text: texto,
        type: 'info'
      }
    );
  }
  
  exibirNaoAlterado(){
    var texto = "O arquivo não alterado.";
            
    this._aslibLoadingService.complete();
    
    new AslibModalComponent(this._aslibModalService).open(
      {
        title: 'Mensagem',
        text: texto,
        type: 'info'
      }
    );
  }

  exibirBloqueado(){
    var texto = "Mudança de status bloqueada o arquivo não pode ser alterado.";
            
    this._aslibLoadingService.complete();
    
    new AslibModalComponent(this._aslibModalService).open(
      {
        title: 'Mensagem',
        text: texto,
        type: 'info'
      }
    );
  }

  exibirCanceladoSemPermissaoAlterarStatus(){

    new AslibModalComponent(this._aslibModalService).open(
      {
      
      title: 'Mensagem',
      text: 'O arquivo não pode ter seu status alterado pois já existe um arquivo com mesmo sequencial no [Status] "Aceito", "Rejeitado", "Gerado" ou "Transmitido".',
      type: 'info'
    }
    
    );
  }

  unSubscribe() {
    this._aslibLoadingService.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/ipm/geracao-arquivo-ipm/geracao-arquivo-ipm.component.ts